var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19L11 0L22 19H0ZM11 16C11.2833 16 11.521 15.904 11.713 15.712C11.905 15.52 12.0007 15.2827 12 15C12 14.7167 11.904 14.479 11.712 14.287C11.52 14.095 11.2827 13.9993 11 14C10.7167 14 10.479 14.096 10.287 14.288C10.095 14.48 9.99933 14.7173 10 15C10 15.2833 10.096 15.521 10.288 15.713C10.48 15.905 10.7173 16.0007 11 16ZM10 13H12V8H10V13Z",
    fill: "#F73C47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.ecafe08da859cb1c88cf72af8f0365b7.svg";
export { ForwardRef as ReactComponent };